/*
 *
 * @desc: 一些自定义产品相关的配置，无法通过接口获取
 * @author: haifn
 * @time: 2021-11-9 10:20:33
 */

import { CountryCode } from '..';

// Tshirt类目特殊处理，不加车改为跳转产品页 / 产品页4个一行 / 没有标签
// https://arashivision.feishu.cn/wiki/SDZJw4bCpii2j7kIuXGcYSUdnSd
const TshirtPids = [592, 593, 594];

const productsUnionByType = {
  nonAccessories: [], // 所有除配件以外的产品类型集合，用于配件取反判断
  consumer_camera: [2, 5, 7, 11, 12, 13, 14, 15, 16, 17, 18, 19, 22, 24, 25, 26, 27], // 消费级相机
  professional_camera: [6, 10], // 专业级相机
  enterprise: [21, 23, 267, 225, 258, 617], // 行业应用
};

// product category 主类目枚举
const PRODUCT_CATEGORY_MAP = {
  CM_CAMERA: '相机',
  CM_HAND_STABILIZER: '手持稳定器',
  CM_WEBCAM: '网络摄像头',
  CM_ACCESSORY: '配件',
  CM_INTERIOR: '内部链接',
  CM_THIRD_PARTY: '第三方合作',
  CM_VIRTUAL_SERVICE: '虚拟服务',
  CM_PERIPHERY: '周边',
  CM_UNCLASSIFIED: '未分类',
};

function handleNonAccessoryType() {
  let nonAccessories = [];
  Object.keys(productsUnionByType).forEach((key) => {
    nonAccessories = [...nonAccessories, ...productsUnionByType[key]];
  });
  productsUnionByType.nonAccessories = nonAccessories;
}
handleNonAccessoryType();

function getBatteryOrChargeHubName({ cid, LANG }) {
  // 电池和充电座配置
  // 用于首页导航栏产品名替换以及产品页
  const batteryAndChargeHub = {
    979: LANG['common.label.ONE_R_battery_name'], // oner电池
    1476: LANG['common.label.ONE_X2_battery_name'], // onex2电池
    102: LANG['common.label.Pro_2_battery_name'], // pro电池
    925: LANG['common.label.Titan_battery_name'], // titan电池
    980: LANG['common.label.ONE_R_fastChargeHub_name'], // oner充电座
    1162: LANG['common.label.ONE_X2_fastChargeHub_name'], // onex2充电座
    103: LANG['common.label.Pro_2_fastChargeHub_name'], // pro充电座
    935: LANG['common.label.Titan_fastChargeHub_name'], // titan充电座
  };
  return batteryAndChargeHub[cid] || null;
}

/** 根据产品id获取类型或返回产品分类 */
const getProductCategory = (product) => {
  const pid = typeof product === 'number' ? product : product.product_id || product.productId || product.id;
  let type;

  Object.keys(productsUnionByType).forEach((i) => {
    if (productsUnionByType[i].includes(pid)) {
      type = i;
    }
  });

  if (!type) {
    // 尝试从产品分类直接获取
    try {
      type = PRODUCT_CATEGORY_MAP[product?.productCategory?.categoryKey];
    } catch (e) {
      type = 'type_error';
    }
  }

  return type;
};

/* 临时预售产品配置 */
const isPreSaleCommodity = ({ cid }) => {
  const preSaleCidList = [
    3196, // VB预售SKU
  ];

  return preSaleCidList.includes(cid);
};

/**
 * @description 退货利益点类型
 * @param {string} countryCode
 * @returns {number} 类型
 */
const getReturnPolicyType = (countryCode) => {
  let type = 1;
  switch (true) {
    case ['CN', 'DE', 'ES', 'FR', 'IT', 'JP', 'KR', 'MO', 'TW', 'US'].includes(countryCode):
      type = 1;
      break;
    case ['AD', 'AT', 'HK', 'HK', 'MX'].includes(countryCode):
      type = 2;
      break;
    case [
      'AE',
      'AU',
      'BN',
      'BR',
      'CA',
      'CH',
      'GB',
      'ID',
      'IL',
      'IN',
      'IS',
      'KW',
      'LI',
      'MC',
      'MY',
      'NO',
      'NZ',
      'PH',
      'RU',
      'SA',
      'SG',
      'TH',
      'VN',
    ].includes(countryCode):
      type = 3;
      break;
    case [
      'BE',
      'BG',
      'CY',
      'CZ',
      'DK',
      'EE',
      'FI',
      'GR',
      'HR',
      'HU',
      'IE',
      'LT',
      'LU',
      'LV',
      'MT',
      'NL',
      'PL',
      'PT',
      'RO',
      'SE',
      'SI',
      'SK',
    ].includes(countryCode):
      type = 4;
      break;
  }
  return type;
};

// 走渠道销售，在前端不展示价格显示的商品类型
export const VB_RELATED = [31, 620, 621, 622, 623, 624, 625, 626];
const CLOUD_RELATED = [572]; // 中国地区云服务不进行销售，但展示价格套餐信息
export const VB_PID = 31;
export const VB_ACCESSORY_PID = [620, 621, 622, 623, 624, 625, 626];

export const isNeedHidePriceProduct = (productId, code = CountryCode) => {
  return (
    (VB_RELATED.includes(productId) && ['CN', 'JP'].includes(code)) ||
    (CLOUD_RELATED.includes(productId) && ['CN'].includes(code))
  );
};

export {
  TshirtPids,
  productsUnionByType,
  getBatteryOrChargeHubName,
  getProductCategory,
  isPreSaleCommodity,
  getReturnPolicyType,
};
